import { createContext, useEffect, useMemo, useState } from 'react'
import Step1 from '../Step1/Step1'
import Step2 from '../Step2/Step2'
import Step3 from '../Step3/Step3'
import Step4 from '../Step4/Step4'

import Box from '@mui/material/Box'
import { Stepper, Step, StepLabel } from '@mui/material'
import useActivationObject from '../../providers/ActivationObjectProvider/hooks/useActivationObject'
import { WizardStepTypeToNumber } from '../../providers/ActivationObjectProvider/helpers'
import { useNavigate } from 'react-router-dom'
import TagManager from 'react-gtm-module'
import { twMerge } from 'tailwind-merge'

interface StepperContextProps {
    activeStep?: number
    setActiveStep: React.Dispatch<React.SetStateAction<number | undefined>>
    showStepper?: boolean
    setShowStepper: React.Dispatch<React.SetStateAction<boolean>>
}

export const StepperContext = createContext<StepperContextProps>({
    activeStep: undefined,
    setActiveStep: () => {},
    showStepper: true,
    setShowStepper: () => {},
})

const Progress = () => {
    const [activeStep, setActiveStep] = useState<number>()
    const [showStepper, setShowStepper] = useState(true)
    const { data: activationObject } = useActivationObject()
    const navigate = useNavigate()

    useEffect(() => {
        if (activationObject) {
            setActiveStep(
                WizardStepTypeToNumber(
                    activationObject.actualWizardStep.mainStep,
                ),
            )
        }
        //else if (isLoaded) window.location.replace('/')
    }, [activationObject, navigate])

    const handleStepBack = () => {
        TagManager.dataLayer({
            dataLayer: {
                event: 'clickBack',
            },
        })
        setActiveStep((prev) => (prev !== undefined && prev > 0 ? prev - 1 : 0))
    }

    // const footerHiddenStates: WizardStepType[] = ['SimpleInfo', 'Finish']
    // const hideBackButton =
    //     activationObject &&
    //     footerHiddenStates.includes(activationObject?.actualWizardStep.mainStep)

    const stepperConfig = useMemo(() => {
        return [
            {
                label: 'Základní informace',
                component: <Step1 onStepBack={handleStepBack}></Step1>,
            },
            {
                label: 'Výběr služby',
                component: <Step2 onStepBack={handleStepBack}></Step2>,
            },
            {
                label: 'Fakturační údaje',
                component: <Step3 onStepBack={handleStepBack}></Step3>,
            },
            {
                label: 'Souhrn',
                component: <Step4 onStepBack={handleStepBack}></Step4>,
            },
        ]
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [activeStep])

    if (!activationObject || activeStep === undefined) return <></>
    return (
        <Box>
            <Box
                className={twMerge(
                    'max-w-[40rem] mx-auto pt-11 pb-16 hidden lg:block',
                )}
            >
                {showStepper ? (
                    <Stepper
                        activeStep={activeStep}
                        alternativeLabel
                        sx={{
                            color: '#525B69',
                            typography: {
                                fontSize: '0,75rem',
                            },
                        }}
                    >
                        {stepperConfig.map((it, index) => (
                            <Step
                                // className='cursor-pointer'
                                key={index}
                                // onClick={() => {
                                //     if (activeStep > index) {
                                //         setActiveStep(index)
                                //         queryClient.refetchQueries()
                                //     }
                                // }}
                            >
                                <StepLabel className='!text-pantone-gray-2'>
                                    {it.label}
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                ) : null}
            </Box>
            <StepperContext.Provider
                value={{
                    activeStep,
                    setActiveStep,
                    showStepper,
                    setShowStepper,
                }}
            >
                {stepperConfig[activeStep].component}
            </StepperContext.Provider>
        </Box>
    )
}

export default Progress
